export const selectDoctors = (state) => state.doctor.doctors;
export const selectDoctorLoading = (state) => state.doctor.loading;
export const selectDoctorError = (state) => state.doctor.error;
